import { zipRecordPermissions } from './recordPermissions'
import type { FgaAssignableRelation, FgaComputedRelation } from './generated/model'

/**
 * What a caller may do to one document: every `can_*` relation the model defines on `document`, paired with the
 * camelCase key it is reported under.
 */
export const DOCUMENT_RECORD_PERMISSIONS = [
  ['canView', 'can_view'],
  ['canEdit', 'can_edit'],
  ['canManage', 'can_manage'],
] as const satisfies readonly (readonly [string, FgaComputedRelation<'document'>])[]

export type DocumentRecordPermissionKey = (typeof DOCUMENT_RECORD_PERMISSIONS)[number][0]

export type DocumentRecordPermissions = Record<DocumentRecordPermissionKey, boolean>

/** The answer for a caller with no access, and the seed every result is built from. */
export const NO_DOCUMENT_RECORD_PERMISSIONS: DocumentRecordPermissions = {
  canView: false,
  canEdit: false,
  canManage: false,
}

export const toDocumentRecordPermissions = (allowed: readonly boolean[]): DocumentRecordPermissions =>
  zipRecordPermissions('document', DOCUMENT_RECORD_PERMISSIONS, NO_DOCUMENT_RECORD_PERMISSIONS, allowed)

/**
 * The one level a person or group added to a document holds, the model relation of the same name: View. Full access
 * on a document comes from marking it, uploading it or the parents, never from the list.
 */
export const DOCUMENT_GRANT_LEVEL = 'viewer' satisfies FgaAssignableRelation<'document'>
